import {
  NewQSetReviewTaskDetailsSection,
  QSetReviewTaskSummary,
} from '@exam-management/qset-review-task-detail';
import { Flex } from '@shared/components';

export default function QSetReviewResultPage() {
  return (
    <Flex
      sx={(theme) => ({
        p: theme.spacing(6),
        gap: theme.spacing(6),
        flexDirection: 'column',
        flex: 1,
      })}
    >
      <NewQSetReviewTaskDetailsSection />
      <QSetReviewTaskSummary />
    </Flex>
  );
}
